/* eslint-disable no-process-env */
/* global process */


export const ENV = {...import.meta.env};

export const LEDGER_WORKTAG = 'Ledger_Account_ID';
export const PERSISTED_STATE_KEY = 'tn-erp-service';
export const APIKEY_HASH_RE: RegExp = /^#\/C\d{5}\/api-key(?:\/|$)/i;
export const API_KEY_PATH_RE: RegExp = /^\/C\d{5}\/api-key\/?$/;
export const POST_LOGIN_REDIRECT_APIKEY_HASH = "postLoginRedirectApiKeyHash";
